import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';

const initialState = {};

const prefix = actionPrefix('login');

// Actions
const TOGGLE_LOGIN_MODAL = prefix('TOGGLE_LOGIN_MODAL');

// Reducers
export default createReducer(initialState, {
  [TOGGLE_LOGIN_MODAL](state, { payload }) {
    return {
      ...state,
      ...payload
    };
  }
});

// Action creators
export const showLoginModal = () => ({
  type: TOGGLE_LOGIN_MODAL,
  payload: { isLexModalDisplayed: true }
});

export const hideLoginModal = () => ({
  type: TOGGLE_LOGIN_MODAL,
  payload: { isLexModalDisplayed: false }
});
